<template>
  <section class="bonus-info-page" data-t="bonus-info-page-4f6d">
    <div class="top-banners">
      <NuxtI18nLink v-if="desktopBonus1" :to="desktopBonus1.url" class="banner">
        <img :src="desktopBonus1.publicUploadUrl" :alt="desktopBonus1.alt" />
      </NuxtI18nLink>
      <NuxtI18nLink v-if="desktopBonus2" :to="desktopBonus2.url" class="banner">
        <img :src="desktopBonus2.publicUploadUrl" :alt="desktopBonus2.alt" />
      </NuxtI18nLink>
    </div>
    <DepositChainPrograms
      v-if="bonusChain"
      :chain="bonusChain"
      :is-default="!isAuthenticated"
      class="chain-programs"
    />
    <BonusesWrapper />
    <NuxtI18nLink v-if="desktopBonus3" :to="desktopBonus3.url" class="banner">
      <img :src="desktopBonus3.publicUploadUrl" :alt="desktopBonus3.alt" />
    </NuxtI18nLink>
  </section>
</template>

<script setup lang="ts">
import BonusesWrapper from './parts/BonusesWrapper.vue'
import { useDefaultBonusesChain } from './useDefaultBonusesChain'
import { useDepositBonusesChain } from '../../composables/useDepositBonusesChain'
import DepositChainPrograms from '../DepositChainPrograms/DepositChainPrograms.vue'
import { useBonusesDeps } from '../../useDeps'

const { isAuthenticated } = useBonusesDeps()

const { banners: desktopBonusesBeforeNotAuthenticatedBanners } = useBanners(
  'desktopBonusesBeforeNotAuthenticated',
)
const { banners: desktopBonusesBeforeAuthenticatedBanners } = useBanners(
  'desktopBonusesBeforeAuthenticated',
)
const { banners: desktopBonusesAfterNotAuthenticatedBanners } = useBanners(
  'desktopBonusesAfterNotAuthenticated',
)
const { banners: desktopBonusesAfterAuthenticatedBanners } = useBanners(
  'desktopBonusesAfterAuthenticated',
)

const desktopBonus1 = computed(() =>
  isAuthenticated.value
    ? desktopBonusesBeforeAuthenticatedBanners.value[0]
    : desktopBonusesBeforeNotAuthenticatedBanners.value[0],
)
const desktopBonus2 = computed(() =>
  isAuthenticated.value
    ? desktopBonusesBeforeAuthenticatedBanners.value[1]
    : desktopBonusesBeforeNotAuthenticatedBanners.value[1],
)

const desktopBonus3 = computed(() =>
  isAuthenticated.value
    ? desktopBonusesAfterAuthenticatedBanners.value[0]
    : desktopBonusesAfterNotAuthenticatedBanners.value[0],
)

const { preparedBonusesChain: defaultBonusesChain } = useDefaultBonusesChain()
const { preparedBonusesChain } = useDepositBonusesChain()

const bonusChain = computed(() =>
  isAuthenticated.value
    ? preparedBonusesChain.value
    : defaultBonusesChain.value,
)
</script>

<style scoped>
.bonus-info-page {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-600);

  margin-bottom: var(--spacing-600);
  padding: 0 var(--spacing-200);
}

.page-title {
  margin: 0;
  font: var(--desktop-text-3xl-semibold);
  color: var(--text-primary);
}

.banner {
  border-radius: var(--border-radius-200);

  img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: var(--border-radius-200);
  }
}

.top-banners {
  overflow: hidden;
  display: flex;
  flex-flow: column;
  gap: var(--spacing-300);
}
</style>
